const data = {
  "storeTime": {
    "closed": "Gesloten",
    "openSoon": "Opent binnenkort",
    "nowOpenUntil": "Nu open, tot {{closeTime}} uur",
    "opensOn": "{{weekday}} open vanaf {{openTime}} uur",
    "opensToday": "Vandaag open vanaf {{openTime}} uur",
    "opensTomorrow": "Morgen open vanaf {{openTime}} uur"
  },
  "storesStockOverlay": {
    "modalTitle": "Winkelvoorraad",
    "pickupOnly": {
      "title": "Haal dit product op in de winkel",
      "description": "Dit product is alleen nog op voorraad in de winkel. Kies hieronder waar je 'm graag ophaalt. Thuis bezorgen kan helaas niet, ook niet via de klantenservice."
    },
    "preOrder": {
      "title": "Dit product is een pre-order",
      "description": "Je kan 'm wel alvast bestellen en op {{releaseDate}} ophalen in de winkel."
    },
    "addToCart": "Reserveren",
    "openingHours": {
      "closed": "Gesloten",
      "storeClosed": "Morgen open, vanaf {{openingTime}} uur",
      "storeOpen": "Open tot {{closingTime}} uur"
    },
    "preferredStore": "Voorkeurswinkel",
    "propositions": {
      "onStock": "Op voorraad",
      "temporaryOutOfStock": "Niet op voorraad",
      "temporaryOutOfStockPickupTomorrow": "Ophalen morgen vanaf {{pickupTime}} uur",
      "temporaryOutOfStockPickup": "Ophalen op {{pickupDay}} vanaf {{pickupTime}} uur",
      "preOrder": "Pre-order",
      "directPickup": "Direct ophalen",
      "nextDayPickup": "Ophalen morgen vanaf {{nextPickupDate}} uur",
      "storePickupToday": "Ophalen vandaag vanaf {{pickupTime}} uur",
      "storePickupAtDay": "Ophalen op {{pickupDay}} vanaf {{pickupTime}} uur",
      "preOrderPickupMoreThanTwoWeeksAway": "Ophalen op release dag {{releaseDate}}",
      "preOrderPickupWithinTwoWeeks": "Ophalen op release dag {{releaseDate}} vanaf {{pickupTime}}",
      "preOrderPickupTomorrow": "Ophalen morgen vanaf {{pickupTime}}",
      "notAvailableForPickup": "Niet te reserveren"
    }
  }
};

export default data;